import React, { useState, useRef, useEffect } from 'react';
import _path from 'ramda/src/path';
import languagesList from '../../../data/languagesSpokenList';
import resx from '../../../utilities/resx';
import {
    RESX_GLOBAL,
} from '../../../Constants';

const EnhancedProfile = ({ enhancedProfile, bioInfo }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [maxHeight, setMaxHeight] = useState('200px');
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.scrollHeight;
            setIsOverflowing(contentHeight > 200);
            setMaxHeight(expanded ? `${contentHeight}px` : '200px');
        }
    }, [expanded, bioInfo, enhancedProfile]);


    const toggleExpanded = () => {
        setExpanded(prev => !prev);
    };

    const getLanguageSpokenLabel = (value) => {
        const language = languagesList.english.find(lang => lang.value === value);
        return language ? language.label : null;
    }

    return (
        <div className="re-enhanced-profile-container">
            <div
                ref={contentRef}
                className="re-enhanced-profile-content"
                style={{ maxHeight }}
            >
                <div>
                    {bioInfo && (
                        <div id="text_user_module" className="component component-profile-bio">
                            <p id="introText" className="re-profile-enhanced-profile-content">
                                <span dangerouslySetInnerHTML={{ __html: bioInfo }} />
                            </p>
                        </div>
                    )}

                    {_path(['YearsExpStr'], enhancedProfile) && (
                        <div className="re-profile-enhanced-profile-year-exp">
                            <span>{enhancedProfile.YearsExpStr}</span>
                        </div>
                    )}

                    {_path(['LicenseNumber'], enhancedProfile) && (
                        <div className="re-profile-enhanced-profile-items">
                            <strong>{resx(RESX_GLOBAL, 'LICENCE_NUMBER')}</strong>
                            <div className="re-profile-enhanced-licence-number">{enhancedProfile.LicenseNumber}</div>
                        </div>
                    )}

                    {(_path(['Languages'], enhancedProfile) || []).length > 0 && (
                        <div className="re-profile-enhanced-profile-items">
                            <strong>{resx(RESX_GLOBAL, 'PROFILE_PROGRESS_ITEM_4')}</strong>
                            <ul>
                                {enhancedProfile.Languages.map((lang, i) => (
                                    <li key={i}>{getLanguageSpokenLabel(lang)}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {(_path(['AreasOfExpertise'], enhancedProfile) || []).length > 0 && (
                        <div className="re-profile-enhanced-profile-items">
                            <strong>{resx(RESX_GLOBAL, 'PROFILE_PROGRESS_ITEM_3')}</strong>
                            <ul>
                                {enhancedProfile.AreasOfExpertise.map((area, i) => (
                                    <li key={i}>{area.Name}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {(_path(['Awards'], enhancedProfile) || []).length > 0 && (
                        <div className="re-profile-enhanced-profile-items">
                            <strong>{resx(RESX_GLOBAL, 'PROFILE_PROGRESS_ITEM_2')}</strong>
                            <ul>
                                {enhancedProfile.Awards.map((award, i) => (
                                    <li key={i}>{award}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {(_path(['Credentials'], enhancedProfile) || []).length > 0 && (
                        <div className="re-profile-enhanced-profile-items">
                            <strong>{resx(RESX_GLOBAL, 'PROFILE_PROGRESS_ITEM_1')}</strong>
                            <ul>
                                {enhancedProfile.Credentials.map((cred, i) => (
                                    <li key={i}>{cred}</li>
                                ))}
                            </ul>
                        </div>
                    )}


                </div>
            </div>

            {/* toggle button */}
            {isOverflowing ? (
                <div className="re-enhanced-profile-toggle">
                    <button type="button" onClick={toggleExpanded} className="">
                        {expanded ? (
                            <div className="re-icon re-icon-primary re-icon-angle-up" />
                        ) : (
                            <div className="re-icon re-icon-primary re-icon-angle-down" />
                        )}
                    </button>
                </div>
            ):null}
        </div>
    );
};

export default EnhancedProfile;
